import React, { useState, useEffect } from 'react';
import CommonCard from "../common/commonCard";
import Header from "../common/header";
import Sidebar from "../common/navBar";
import { Container, Row, Col, Button } from 'react-bootstrap';
import NormativeCard from '../specific/normativeCard';
import { useLocation } from 'react-router-dom';
import Footer from '../common/footer';
import { useTranslation } from "react-i18next";

const NormativeComponent = () => {
    const [t] = useTranslation("legal")
    const [expanded, setExpanded] = useState(false);
    const location = useLocation();


    const normativa1 = 'https://www.boe.es/buscar/doc.php?id=DOUE-L-2016-80807';
    const normativa2 = 'https://www.boe.es/diario_boe/txt.php?id=BOE-A-2018-16673';
    const normativa3 = 'https://boe.es/buscar/doc.php?id=BOE-A-2023-4513#:~:text=Ley%202%2F2023%2C%20de%2020%20de%20febrero%2C%20reguladora%20de,de%202023%2C%20p%C3%A1ginas%2026140%20a%2026189%20%2850%20p%C3%A1gs.%29';
    const normativa4 = 'https://www.boe.es/buscar/doc.php?id=DOUE-L-2019-81812';
    const normativa5 = 'https://www.boe.es/boe/dias/2024/10/30/pdfs/BOE-A-2024-22298.pdf';



    return (
        <div>
            <Header
                manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
            />
            <Container fluid>
                <Row>
                    <Col className='d-flex' style={{ paddingLeft: 0, paddingRight: 0, flex: `0 0 ${expanded ? '2%' : '4%'}` }}>
                        <Sidebar expanded={expanded} setExpanded={setExpanded} selected={'Normativa'} />
                    </Col>
                    <Col
                        className='custom-content-wrapper'
                        style={{ marginLeft: `0.5%`, paddingRight: 0, flex: `0 0 ${expanded ? '88%' : '93%'}` }}>
                        <Row>
                            {/* Columna principal para los Col md={8} */}
                            <Col md={12}>
                                <Row>
                                    {/* Primer CommonCard */}
                                    <Col md={12}>
                                        <CommonCard title={t("card.title")}  icon={'FaBook'}>
                                            <div className='common-card-card-content-card'>
                                                <NormativeCard icon={'FaUserLock'} hyperLink={normativa1} text={t("legalCards.normative1")} statusColor={'red'} />
                                                <NormativeCard icon={'FaGlobeEurope'} hyperLink={normativa2} text={t("legalCards.normative2")} statusColor={'yellow'} />
                                                <NormativeCard icon={'FaShieldAlt'} hyperLink={normativa3} text={t("legalCards.normative3")} statusColor={'blue'} />
                                                <NormativeCard icon={'FaUserShield'} hyperLink={normativa4} text={t("legalCards.normative4")} statusColor={'green'} />
                                                <NormativeCard icon={'FaGavel'} hyperLink={normativa5} text={t("legalCards.normative5")} statusColor={'purple'} />
                                            </div>
                                        </CommonCard>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Footer />
                    </Col>
                </Row>
            </Container>
        </div>
    );

}

export default NormativeComponent;
